import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';

import { formatDate } from '../../utils/functions';
import { ElementLink } from '../../components';

export class FlashOfferCell extends Component {
  render() {
    const { offer } = this.props;

    function storeName() {
      return offer.store ? offer.store.name : '';
    }

    return (
      <ElementLink
        element="tr"
        to={`/offers/${offer.id}/edit`}
        className="offer-cell"
      >
        <td className="offer-cell-store">{storeName()}</td>
        <td className="offer-cell-title">{offer.title}</td>
        <td className="offer-cell-start-date">{formatDate(offer.startDate)}</td>
        <td className="offer-cell-end-date">{formatDate(offer.endDate)}</td>
      </ElementLink>
    );
  }
}

export default createFragmentContainer(FlashOfferCell, {
  offer: graphql`
    fragment FlashOfferCell_offer on Offer {
      id
      title
      startDate
      endDate
      store {
        name
      }
    }
  `,
});
